/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milk or BSA for blocking?`)
};

const es_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Leche o BSA para el bloqueo?`)
};

const de_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milch oder BSA zum Blockieren?`)
};

const nl_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melk of BSA voor blokkering?`)
};

const fr_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lait ou BSA pour le blocage ?`)
};

const it_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latte o BSA per il blocco?`)
};

const pt_br2_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leite ou BSA para bloqueio?`)
};

const pt_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leite ou BSA para bloqueio?`)
};

const ja_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブロッキングにはミルクとBSAどちらを使うべきですか?`)
};

const zh_buf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封闭该用脱脂奶还是 BSA？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_q3", locale)
	if (locale === "en") return en_buf_faq_q3(inputs)
	if (locale === "es") return es_buf_faq_q3(inputs)
	if (locale === "de") return de_buf_faq_q3(inputs)
	if (locale === "nl") return nl_buf_faq_q3(inputs)
	if (locale === "fr") return fr_buf_faq_q3(inputs)
	if (locale === "it") return it_buf_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_q3(inputs)
	if (locale === "pt") return pt_buf_faq_q3(inputs)
	if (locale === "ja") return ja_buf_faq_q3(inputs)
	return zh_buf_faq_q3(inputs)
};